document.addEventListener('DOMContentLoaded', function () {
  // Function to apply styles when the element is found
  function applyStyles() {
    const shadowHost = document.querySelector('square-placement');

    if (shadowHost && shadowHost.shadowRoot) {
      const afterpayParagraph = shadowHost.shadowRoot.querySelector('.afterpay-paragraph');

      if (afterpayParagraph) {
        afterpayParagraph.style.display = 'flex';
        afterpayParagraph.style.flexDirection = 'row';
        afterpayParagraph.style.alignItems = 'center';
        afterpayParagraph.style.justifyContent = 'start';
        afterpayParagraph.style.margin = '12px 0';
        afterpayParagraph.style.gap = '4px';
        window.innerWidth < 768 && (afterpayParagraph.style.fontSize = '12px');
        return true;
      }
    }
    return false; // Element not found yet
  }

  // Try immediately
  if (!applyStyles()) {
    // If not successful, set up a MutationObserver
    const observer = new MutationObserver(function (mutations) {
      if (applyStyles()) {
        observer.disconnect(); // Stop observing once styles are applied
      }
    });

    // Start observing the document with the configured parameters
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    // Fallback: try again after a short delay
    setTimeout(() => {
      if (applyStyles()) {
        observer.disconnect();
      }
    }, 1000);
  }
});
